import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/views/Layout.vue'
import LayoutTwo from '@/views/LayoutTwo.vue'
Vue.use(VueRouter)



const routes = [
  {
    path:'/',
    redirect:'/loding'
  },
  {
    path:'/loding',
    component:()=>import('../views/Loding.vue')
  },
  {
    path: '/home',
    component:Layout,
    meta:{title:'黑龙江省级地图',path:'/home'},
    children:[
      {
        path:'/',
        component:()=>import('../views/Home.vue')
      },
      {
            path:'changfeng',//长丰风电场
            meta:{title:'长丰风电场',path:'/home/changfeng'},
            component:LayoutTwo,
            children:[
              {
                path:'/',
                component:()=>import('../views/ChangFeng.vue'),
              },
              {
                path:'machine',//风机
                meta:{title:'风机',path:'/home/changfeng/machine'},
                component:()=>import('../views/Machine.vue')
              }
            ]
          },
          {
            path:'changrong',//长荣风电场
            meta:{title:'长荣风电场',path:'/home/changrong'},
            component:LayoutTwo,
            children:[
              {
                path:'/',
                component:()=>import('../views/ChangFeng.vue'),
              },
              {
                path:'machine',//风机
                meta:{title:'风机',path:'/home/changrong/machine'},
                component:()=>import('../views/Machine.vue')
              }
            ]
          },
          {
            path:'heping',//和平风电场
            meta:{title:'和平风电场',path:'/home/heping'},
            component:LayoutTwo,
            children:[
              {
                path:'/',
                component:()=>import('../views/ChangFeng.vue'),
              },
              {
                path:'machine',//风机
                meta:{title:'风机',path:'/home/heping/machine'},
                component:()=>import('../views/Machine.vue')
              }
            ]
          },
          {
            path:'xinhai',//新海风电场
            meta:{title:'新海风电场',path:'/home/xinhai'},
            component:LayoutTwo,
            children:[
              {
                path:'/',
                component:()=>import('../views/ChangFeng.vue'),
              },
              {
                path:'machine',//风机
                meta:{title:'风机',path:'/home/xinhai/machine'},
                component:()=>import('../views/Machine.vue')
              }
            ]
          },
          {
            path:'luobei',//萝北风电场
            meta:{title:'萝北新垦风电场',path:'/home/luobei'},
            component:LayoutTwo,
            children:[
              {
                path:'/',
                component:()=>import('../views/ChangFeng.vue'),
              },
              {
                path:'machine',//风机
                meta:{title:'风机',path:'/home/luobei/machine'},
                component:()=>import('../views/Machine.vue')
              }
            ]
          },
          {
            path:'tongjiang',//同江风电场
            meta:{title:'同江街津山风电场',path:'/home/tongjiang'},
            component:LayoutTwo,
            children:[
              {
                path:'/',
                component:()=>import('../views/ChangFeng.vue'),
              },
              {
                path:'machine',//风机
                meta:{title:'风机',path:'/home/tongjiang/machine'},
                component:()=>import('../views/Machine.vue')
              }
            ]
          }
    ]
  }
]


const router = new VueRouter({
  routes
})

 
//获取原型对象上的push函数
const originalPush = VueRouter.prototype.replace
//修改原型对象中的push方法
VueRouter.prototype.replace = function replace(location) {
return originalPush.call(this, location).catch(err => err)
}



export default router
